import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_PROVIDER_WITH_VENDOR_INFO_REQUEST: '', // post
  GET_PROVIDER_WITH_VENDOR_INFO_SUCCESS: '',
  GET_PROVIDER_WITH_VENDOR_INFO_FAILURE: '',

  GET_PROVIDER_NAME_REQUEST: '',
  GET_PROVIDER_NAME_SUCCESS: '',
  GET_PROVIDER_NAME_FAILURE: '',

  IS_PCP_REQUEST: '',
  IS_PCP_SUCCESS: '',
  IS_PCP_FAILURE: '',

  IS_ARCADIA_REQUEST: '',
  IS_ARCADIA_SUCCESS: '',
  IS_ARCADIA_FAILURE: '',

  GET_IPA_ADVISE_REQUEST: '',
  GET_IPA_ADVISE_SUCCESS: '',
  GET_IPA_ADVISE_FAILURE: '',

  GET_AUTH_SEARCH_PROVIDER_LIST_REQUEST: '', // post
  GET_AUTH_SEARCH_PROVIDER_LIST_SUCCESS: '',
  GET_AUTH_SEARCH_PROVIDER_LIST_FAILURE: '',

  GET_PROVIDER_BY_CITY_REQUEST: '', // post
  GET_PROVIDER_BY_CITY_SUCCESS: '',
  GET_PROVIDER_BY_CITY_FAILURE: '',

  GET_PROVIDER_BY_NAME_REQUEST: '', // post
  GET_PROVIDER_BY_NAME_SUCCESS: '',
  GET_PROVIDER_BY_NAME_FAILURE: '',

  GET_AUTH_ENABLED_PROVIDER_LIST_REQUEST: '', // post
  GET_AUTH_ENABLED_PROVIDER_LIST_SUCCESS: '',
  GET_AUTH_ENABLED_PROVIDER_LIST_FAILURE: '',

  POST_ACKNOWLEDGEMENT_REQUEST: '',
  POST_ACKNOWLEDGEMENT_SUCCESS: '',
  POST_ACKNOWLEDGEMENT_FAILURE: '',

  CHECK_INITIAL_FOLLOW_UP_REQUEST: '',
  CHECK_INITIAL_FOLLOW_UP_SUCCESS: '',
  CHECK_INITIAL_FOLLOW_UP_FAILURE: '',

  GET_ALL_IPA_PROVIDERS_REQUEST: '',
  GET_ALL_IPA_PROVIDERS_SUCCESS: '',
  GET_ALL_IPA_PROVIDERS_FAILURE: '',

  SEARCH_ALL_PROVIDERS_REQUEST: '',
  SEARCH_ALL_PROVIDERS_SUCCESS: '',
  SEARCH_ALL_PROVIDERS_FAILURE: '',

  GET_AUTH_PROVIDER_HCC_REQUEST: '',
  GET_AUTH_PROVIDER_HCC_SUCCESS: '',
  GET_AUTH_PROVIDER_HCC_FAILURE: '',

  GET_CEC_PROVIDERS_REQUEST: '',
  GET_CEC_PROVIDERS_SUCCESS: '',
  GET_CEC_PROVIDERS_FAILURE: '',

  GET_PROVIDER_TERM_DATE_REQUEST: '',
  GET_PROVIDER_TERM_DATE_SUCCESS: '',
  GET_PROVIDER_TERM_DATE_FAILURE: '',

  GET_EZ_PROVIDER_DETAILS_REQUEST: '',
  GET_EZ_PROVIDER_DETAILS_SUCCESS: '',
  GET_EZ_PROVIDER_DETAILS_FAILURE: '',

  GET_CHECK_PROVIDER_AUTH_SUBMISSION_REQUEST: '',
  GET_CHECK_PROVIDER_AUTH_SUBMISSION_SUCCESS: '',
  GET_CHECK_PROVIDER_AUTH_SUBMISSION_FAILURE: '',

};

types = setStoreTypeValues(types, 'authProvider');

export default types;
